var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',[_c('div',{staticClass:"ml-auto"},[_c('span',{staticClass:"ml-1"},[_vm._v("Powered by ESYMED Co.,Ltd")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }